// app/javascript/packs/application.js

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import { DateTime } from 'luxon';

Rails.start()
ActiveStorage.start()

// CSS・JSライブラリの読み込み
import 'bootstrap'
import '../stylesheets/application.scss'
import '../stylesheets/calendar.css'
import '../stylesheets/timeline.css'
import "@fortawesome/fontawesome-free/js/all"
import "flatpickr/dist/flatpickr.css";
import "../customers/autocomplete";
import "./dropzone";
import "dropzone/dist/dropzone.css";
import "./calculator";

import * as jQuery from 'jquery';
window.$ = window.jQuery = jQuery;
import "lightbox2";
//import 'lightbox2/dist/js/lightbox-plus-jquery.min.js';


// ⭐⭐⭐ slideshow_helper.js ⭐⭐⭐
import { generateSlideshow } from '../utils/carousel_helper';
window.generateSlideshow = generateSlideshow;
import '../stylesheets/slideshow.scss';

// Turbo
import "@hotwired/turbo-rails"
import { Turbo } from "@hotwired/turbo-rails"

// Bootstrap をグローバル変数に
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap

// ✅ Stimulus controller 読み込み（index.js 経由で自動登録）
import "controllers"

import './drawing'


// Bootstrap モーダル制御
document.addEventListener('shown.bs.modal', function (event) {
  const modal = event.target;
  if (modal && modal.classList.contains('modal')) {
    modal.setAttribute('aria-hidden', 'false');
  }
});

document.addEventListener('hidden.bs.modal', function (event) {
  const modal = event.target;
  if (modal && modal.classList.contains('modal')) {
    modal.setAttribute('aria-hidden', 'true');
    setTimeout(() => {
      document.activeElement.blur();
      document.body.focus();
    }, 0);
  }
});

// Turboキャッシュ前にモーダルを完全にクリーンアップ
document.addEventListener('turbo:before-cache', () => {
  const modals = document.querySelectorAll('.modal.show, .modal.fade');
  modals.forEach((modalEl) => {
    const modalInstance = bootstrap.Modal.getInstance(modalEl);
    if (modalInstance) {
      modalInstance.hide();
      modalInstance.dispose();
    }
    modalEl.remove();
  });
});

// タイムラインスクロール同期
document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".timeline-wrapper");
  if (!wrapper) return;
  const staffCells = wrapper.querySelectorAll(".staff-name-cell");

  wrapper.addEventListener("scroll", function () {
    const scrollLeft = wrapper.scrollLeft;
    staffCells.forEach(cell => {
      cell.style.transform = `translateX(${scrollLeft}px)`;
    });
  });
});

// ✅ Flatpickr 多言語対応
import flatpickr from "flatpickr";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
import { Mandarin } from "flatpickr/dist/l10n/zh.js";
import { Vietnamese } from "flatpickr/dist/l10n/vn.js";
import { English } from "flatpickr/dist/l10n/default.js"; // デフォルトは英語

document.addEventListener("turbo:load", () => {
  flatpickr(".flatpickr-datetime", {
    enableTime: true,
    dateFormat: "Y-m-d H:i",
    time_24hr: true,
    minuteIncrement: 15,
  });

  const lang = document.documentElement.lang || "ja";
  const locale = lang.startsWith("zh") ? Mandarin
    : lang.startsWith("vi") ? Vietnamese
    : lang.startsWith("en") ? English
    : Japanese;

  flatpickr(".datepicker", {
    locale: locale,
    dateFormat: "Y-m-d"
  });
});

// Stimulusを使わずドロワー制御
document.addEventListener("turbo:load", () => {
  const drawer = document.getElementById("drawer");
  const backdrop = document.getElementById("drawerBackdrop");
  const openBtn = document.getElementById("openResCustomerDrawerBtn");
  const closeBtn = document.getElementById("closeResCustomerDrawerBtn");

  if (!drawer || !backdrop || !openBtn || !closeBtn) return;

  openBtn.addEventListener("click", () => {
    drawer.classList.add("open");
    backdrop.classList.add("show");
  });

  closeBtn.addEventListener("click", () => {
    drawer.classList.remove("open");
    backdrop.classList.remove("show");
  });

  backdrop.addEventListener("click", () => {
    drawer.classList.remove("open");
    backdrop.classList.remove("show");
  });
});

// console.log("★★★ MY autocomplete.js has been loaded ★★★");

document.addEventListener("DOMContentLoaded", () => {
  // console.log("★★★ DOMContentLoaded fired ★★★");
});

document.addEventListener("turbo:load", () => {
  const toastElList = [].slice.call(document.querySelectorAll('.flash-toast'))
  toastElList.forEach(toastEl => {
    const toast = new bootstrap.Toast(toastEl, { delay: 4000 })
    toast.show()
  })
})

document.addEventListener('turbo:load', () => {
  const el = document.getElementById('shop_local_time');
  if (!el || !window.SHOP_TIMEZONE) return;

  const updateTime = () => {
    const now = DateTime.now().setZone(window.SHOP_TIMEZONE);
    const formatted = now.toFormat("yyyy/MM/dd (ccc) HH:mm:ss");
    // 例: 2025年05月27日 (火) 10:03:22 JST
    el.innerHTML = `<i class="fa-regular fa-clock"></i> ${formatted} （${window.SHOP_TIMEZONE}）`;
  };

  updateTime();              // 初回表示
  setInterval(updateTime, 1000);  // 毎秒更新
});

document.addEventListener('turbo:load', () => {
  document.querySelectorAll('[data-parent-id]').forEach(link => {
    link.addEventListener('click', (event) => {
      // リンクのデフォルト動作（href="#"）を停止
      event.preventDefault();
      
      const parentId = event.currentTarget.dataset.parentId;
      const parentName = event.currentTarget.dataset.parentName;

      // フォームのparent_idフィールドを更新
      const parentSelect = document.getElementById('category_parent_id');
      if (parentSelect) {
        parentSelect.value = parentId;
      }
      
      // 親カテゴリー名を表示する要素を更新
      const parentNameDisplay = document.getElementById('parentNameDisplay');
      if (parentNameDisplay) {
        parentNameDisplay.textContent = `（${parentName}）`;
      }
    });
  });
});

document.addEventListener('turbo:load', function() {
  const tipsModal = document.getElementById('customerTipsModal');
  if (tipsModal) {
    tipsModal.addEventListener('show.bs.modal', function(event) {
      const button = event.relatedTarget;
      const data = JSON.parse(button.getAttribute('data-customer-tips'));
      
      // --- 1. 基本情報の更新 ---
      document.getElementById('tipsCustomerName').textContent = data.name;
      document.getElementById('tipsCustomerAltId').textContent = `ID: ${data.alt_id}`;
      document.getElementById('tipsAgeInfo').textContent = data.age_info;
      document.getElementById('tipsVisitCount').textContent = data.visit_count;
      document.getElementById('tipsCustomerMemo').textContent = data.memo;
      document.getElementById('tipsDetailLink').setAttribute('href', data.detail_url);

      // --- 2. ポイント1 (Mileage/Ticket) の制御 ---
      const mRow = document.getElementById('tipsMileageRow');
      const mCont = document.getElementById('tipsMileageContainer');
      if (mRow && mCont) {
        if (data.mileage_val !== null && data.mileage_val !== undefined) {
          // 値がある場合は表示
          mCont.innerHTML = `${data.mileage_val}<i class="fa-solid fa-p text-primary ms-1"></i>`;
          mRow.classList.remove('d-none');
          mRow.classList.add('d-flex');
        } else {
          // 値がない（運用なし）場合は行ごと隠す
          mRow.classList.remove('d-flex');
          mRow.classList.add('d-none');
        }
      }

      // --- 3. ポイント2 (Juice) の制御 ---
      const jRow = document.getElementById('tipsJuiceRow');
      const jCont = document.getElementById('tipsJuiceContainer');
      if (jRow && jCont) {
        if (data.juice_val !== null && data.juice_val !== undefined) {
          // 値がある場合は表示
          jCont.innerHTML = `${data.juice_val}<i class="fa-solid fa-j text-warning ms-1"></i>`;
          jRow.classList.remove('d-none');
          jRow.classList.add('d-flex');
        } else {
          // 値がない（運用なし）場合は行ごと隠す
          jRow.classList.remove('d-flex');
          jRow.classList.add('d-none');
        }
      }
    });
  }
});